import { createFeatureSelector } from "redux/utility"

export const reducerName = "entities" as const

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createEntitiesFeatureSelector = (featureName: string) =>
    createFeatureSelector(`${reducerName}.${featureName}`)
